import { timezoneDayjs as dayjs } from '@travel/traveler-core/utils/jrdpHelper';

export const DEFAULT_ROOM = 1;
export const DEFAULT_ADULT = 1;
export const DEFAULT_CHILDREN = 0;
export const DEFAULT_STAY_NIGHT = 1;

export const DEFAULT_CHILDREN_UPPER_GRADE = 0;
export const DEFAULT_CHILDREN_LOWER_GRADE = 0;
export const DEFAULT_INFANT_BED_MEAL = 0;
export const DEFAULT_INFANT_MEAL_ONLY = 0;
export const DEFAULT_INFANT_BED_ONLY = 0;
export const DEFAULT_INFANT_NONE = 0;

export const MAX_ADULT_COUNT = 10;
export const MAX_ADULT_COUNT_OVERSEAS = 9;
export const MAX_KID_COUNT = 10;
export const MAX_KID_COUNT_OVERSEAS = 5;
export const MAX_ROOM_COUNT = 10;
export const MAX_STAY_NIGHT = 100;

export enum URL_KEYS {
  /** AmountInput */
  CHILDREN_UPPER_GRADE = 'f_s1',
  CHILDREN_LOWER_GRADE = 'f_s2',
  INFANT_BED_MEALS = 'f_y1',
  INFANT_MEAL = 'f_y2',
  INFANT_BED = 'f_y3',
  INFANT_NONE = 'f_y4',
  NO_OF_UNITS = 'f_heya_su',
  ADULTS = 'f_otona_su',
  /** DateInput */
  CHECK_IN_DAY = 'f_hi1',
  CHECK_IN_MONTH = 'f_tuki1',
  CHECK_IN_YEAR = 'f_nen1',
  CHECK_OUT_DAY = 'f_hi2',
  CHECK_OUT_MONTH = 'f_tuki2',
  CHECK_OUT_YEAR = 'f_nen2',
  /** Common - Domestic & Overseas */
  SORT = 'f_sort',
  DAI = 'f_dai',
  /** Common - Domestic */
  HYOJI = 'f_hyoji',
  IMAGE = 'f_image',
  /** Common - Overseas */
  PAGE = 'f_page',
  KIN = 'f_kin',
  KIN2 = 'f_kin2',
  FAVORITE = 'f_favorite',
  TAB = 'f_tab',
  /** Hotel List */
  NUMBER = 'f_no', // Domestic
  HOTEL_LIST = 'f_hotel_list', // Overseas
}
type Sort = 'kin' | 'hotel';
type Dai = 'japan' | 'kaigai';
type HotelNumbers = string;
interface ICommonFormValues {
  [URL_KEYS.SORT]: Sort;
  [URL_KEYS.DAI]: Dai;
  [URL_KEYS.FAVORITE]: 1;
}
interface DomesticCommonFormValues extends ICommonFormValues {
  [URL_KEYS.HYOJI]: number;
  [URL_KEYS.IMAGE]: number;
  [URL_KEYS.NUMBER]: HotelNumbers;
}
interface OverseasCommonFormValues extends ICommonFormValues {
  [URL_KEYS.PAGE]: 1;
  [URL_KEYS.KIN]: '';
  [URL_KEYS.KIN2]: 0;
  [URL_KEYS.TAB]: 'hotel';
  [URL_KEYS.HOTEL_LIST]: HotelNumbers;
}
type CommonFormValues<T extends DomesticCommonFormValues | OverseasCommonFormValues> =
  T extends OverseasCommonFormValues ? OverseasCommonFormValues : DomesticCommonFormValues;

interface CreateCommonFormValuesValues {
  hotelNumbers: number[];
}

export function createCommonFormValues<T extends true | false = true>(
  values: CreateCommonFormValuesValues,
  isDomestic?: T,
): CommonFormValues<T extends true ? DomesticCommonFormValues : OverseasCommonFormValues>;
export function createCommonFormValues(
  values: CreateCommonFormValuesValues,
  isDomestic: boolean = true,
): DomesticCommonFormValues | OverseasCommonFormValues {
  const commonFormValues: DomesticCommonFormValues | OverseasCommonFormValues = {
    [URL_KEYS.SORT]: (isDomestic ? 'kin' : 'hotel') as Sort,
    [URL_KEYS.DAI]: (isDomestic ? 'japan' : 'kaigai') as Dai,
    [URL_KEYS.FAVORITE]: 1,
    ...(isDomestic
      ? {
          [URL_KEYS.HYOJI]: 30,
          [URL_KEYS.IMAGE]: 1,
          [URL_KEYS.NUMBER]: values.hotelNumbers?.join(','),
        }
      : {
          [URL_KEYS.PAGE]: 1,
          [URL_KEYS.KIN]: '',
          [URL_KEYS.KIN2]: 0,
          [URL_KEYS.TAB]: 'hotel',
          [URL_KEYS.HOTEL_LIST]: values.hotelNumbers?.join(','),
        }),
  };
  return commonFormValues;
}

const EARLIEST_BOOKING_DATE_TIME_CUTOFF_HOUR = 24;
const DAYS_FROM_TODAY_FOR_EARLIEST_BOOKING = 0;

export const getEarliestDate = (formatType?: string) => {
  const today = dayjs();
  const isTimeOnOrAfterCutoffTime = today.hour() >= EARLIEST_BOOKING_DATE_TIME_CUTOFF_HOUR;
  const earliestPossibleBookingDay = today.add(
    DAYS_FROM_TODAY_FOR_EARLIEST_BOOKING + (isTimeOnOrAfterCutoffTime ? 1 : 0),
    'day',
  );
  return !!formatType ? earliestPossibleBookingDay.format(formatType) : earliestPossibleBookingDay;
};
